import { useEffect } from 'react';

import { useStores } from '~store';

import useThemeMode from './useThemeMode';

/**
 * Adopts the server-persisted theme (`user.preferences.appearance.theme`) into
 * the ThemeMode context once the authenticated user loads, so a saved
 * preference follows the user across devices/browsers.
 *
 * MUST be called from an `observer` component so it reacts when the user record
 * arrives. The effect keys on the server value only: a later local selection
 * (which does not change the stored user record) is never reverted, and the
 * effect re-reconciles only when the server value genuinely changes.
 */
export default function useHydrateThemeFromUser() {
  const { userStore } = useStores();
  const { setMode } = useThemeMode();
  const serverTheme = userStore.user?.preferences?.appearance?.theme;

  useEffect(() => {
    if (serverTheme) {
      setMode(serverTheme);
    }
  }, [serverTheme, setMode]);
}
